import { useLanguage } from '../../context/LanguageContext';
import { translations } from '../../helpers/language';
import parse from 'html-react-parser';

const HeroSection = () => {
    const { language } = useLanguage();
    const t = translations[language].hero;

    return (
        <section id="hero" className="section-running" data-aos="fade-up">
            <div className="running-left">
                <h1 className="solution-title">
                    {t.title_part1}
                    <span className="text-span-8">{t.title_highlight}</span>
                </h1>
                <p className="solution-paragraph">
                    {t.paragraph.map((line, index) => (
                        <span key={index}>
                            {parse(line)}
                            <br /><br />
                        </span>
                    ))}
                </p>
            </div>
            <div className="solutions-rigth"></div>
        </section>
    );
};

export default HeroSection;
